module.exports = __webpack_public_path__ + "static/media/52_tn.a4e4eabd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/52_tn.jpg
// module id = 688
// module chunks = 0